import React from 'react';
// Components
import AffiliateStreamsTable from 'components/common/AffiliateStreamsTable/AffiliateStreamsTable';

const AffiliateStreams = (): JSX.Element => {
  return <AffiliateStreamsTable />;
};

export default AffiliateStreams;
